<div
[ngClass]="'image-with-blockquote flex-container flex-dir-column align-justify ' + (secondary ? 'image-with-blockquote--secondary' : '')"
>
  <div aria-hidden="true"
  data-test="mono-common-blockquote-image-image"
  [ngClass]="'image-with-blockquote__image banner-image--pixel-depth_1x ' + (secondary ? 'image-with-blockquote__image--secondary' : '')"
  [ngStyle]="{'background-image': 'url(' + imageSrc + ')'}" data-test="mono-common-blockquote-image-image">
  </div>
  <div aria-hidden="true"
  [ngClass]="'image-with-blockquote__image banner-image--pixel-depth_2x ' + (secondary ? 'image-with-blockquote__image--secondary' : '')"
  [ngStyle]="{'background-image': 'url(' + (image2xSrc ? image2xSrc : imageSrc) + ')'}" data-test="mono-common-blockquote-image-image2x">
  </div>
  <blockquote
    [ngClass]="'flex-container image-with-blockquote__blockquote ' + (secondary ? 'image-with-blockquote__blockquote--secondary' : '')"
  >
    <svg
      data-test="mono-common-blockquote-quote-svg"
      aria-hidden="true"
      viewBox="0 0 36 36"
      [ngClass]="'icon ' + quoteSvg"
    >
      <use
        attr.xlink:href="{{'#' + quoteSvg}}"
        attr.href="{{'#' + quoteSvg}}"
      ></use>
    </svg>
    <p class="margin-0 padding-0">
      {{ quote }}
    </p>
  </blockquote>
</div>